import { useContext } from "react";
import { useParams } from "react-router-dom";

import InterpretationTabContent from "@/components/reports/InterpretationTabContent";
import useCardList from "@/hooks/useCardList";
import { ViewerContext } from "@/tpo/Viewer";

import Template from "../shared/Template";
import { REPORT_DETAIL_QUERY, REPORT_RESULTS_QUERY, REPORTS_LIST_QUERY, USER_RESULT_INTERPRETATION_DETAILS_QUERY, WARD_ENTITLEMENTS_QUERY } from "./graphql/queries";
import CardListContext from "@/contexts/CardListContext";
import OverviewTab from "@/components/customerView/reports/reportDetail/OverviewTab";
import WardRelatedTestsSection from "./reportDetail/RelatedTestsSection";

function WardOverviewTab(props) {
  const { reportSlug } = useParams();
  const { userId } = useContext(ViewerContext);
  const printUrl =
    userId && reportSlug ? `/patients/${userId}/reports/${reportSlug}/print` : undefined;

  return <OverviewTab {...props} RelatedTestsSection={WardRelatedTestsSection} printUrl={printUrl} />;
}
import InterpretationCard from "@/components/reports/InterpretationCard";
import ChartModal from "@/tpo/ChartModal";
import ModelContent from "../testResults/ModelContent";
import { ReportDetailContent } from "@/components/customerView/reports/ReportDetail";
import { useQuery } from "@apollo/client";

function WardReportDetailContent() {
  const { reportSlug } = useParams();
  const { userId } = useContext(ViewerContext);
  const { cardOpen, setCardOpen, viewCard } = useCardList();

  const TABS = [
    { value: "overview", label: "Overview" },
    { value: "summary", label: "Summary", disabled: true },
    { value: "interpretation", label: "Interpretation" },
    { value: "suggestions", label: "Suggestions", disabled: true },
    { value: "tests", label: "Tests", disabled: true }
  ];

  const { data: entitlementsData } = useQuery(WARD_ENTITLEMENTS_QUERY, {
    variables: {
      userId
    },
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first",
  });

  return (
    <CardListContext.Provider
      value={{
        viewCard
      }}
    >
      <ReportDetailContent
        listQuery={REPORTS_LIST_QUERY}
        listQueryVariables={{
          userId
        }}
        detailQuery={REPORT_DETAIL_QUERY}
        detailQueryVariables={{
          subsectorSlug: reportSlug,
          userId
        }}
        tabs={TABS}
        getReportUrl={(reportSlug, tab = "overview") => `/patients/${userId}/reports/${reportSlug}/${tab}`}
        UnlockedOverviewTabContent={WardOverviewTab}
        SummaryTabContent={() => null}
        InterpretationTabContent={InterpretationTabContent}
        interpretationQuery={REPORT_RESULTS_QUERY}
        interpretationQueryVariables={{
          subsectorSlug: reportSlug,
          userId
        }}
        interpretationListCard={InterpretationCard}
        interpretationListCardQuery={USER_RESULT_INTERPRETATION_DETAILS_QUERY}
        interpretationListCardQueryVariables={{
          subsectorSlug: reportSlug,
          userId
        }}
        SuggestionsTabContent={() => null}
        userEntitlements={entitlementsData?.user?.entitlements}
      />
      <ChartModal close={() => setCardOpen(undefined)} show={!!cardOpen?.type}>
        <ModelContent type={cardOpen?.type} item={cardOpen?.item} />
      </ChartModal>
    </CardListContext.Provider>
  );
}

export default function WardReportDetail() {
  return (
    <Template selectedTab="reports" docTitle="Report detail">
      <WardReportDetailContent />
    </Template>
  );
}
